var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteAddVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-282.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-video",
    transform: "translate(282.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#DCE4F4",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 7,
    y: 8,
    width: 12,
    height: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-video-thumbnail",
    transform: "translate(6.500000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2857143,0 L0.714285714,0 C0.319796607,-3.85558291e-17 1.73733623e-16,0.319796607 0,0.714285714 L0,9.28571429 C1.09944112e-15,9.68020339 0.319796607,10 0.714285714,10 L12.2857143,10 C12.6802034,10 13,9.68020339 13,9.28571429 L13,0.714285714 C13,0.319796607 12.6802034,-8.49622591e-16 12.2857143,0 Z M5.88095238,8.125 L7.11904762,8.125 L7.11904762,9.375 L5.88095238,9.375 L5.88095238,8.125 Z M8.35714286,8.125 L9.5952381,8.125 L9.5952381,9.375 L8.35714286,9.375 L8.35714286,8.125 Z M10.8333333,8.125 L12.0714286,8.125 L12.0714286,9.375 L10.8333333,9.375 L10.8333333,8.125 Z M3.4047619,8.125 L4.64285714,8.125 L4.64285714,9.375 L3.4047619,9.375 L3.4047619,8.125 Z M0.928571429,8.125 L2.16666667,8.125 L2.16666667,9.375 L0.928571429,9.375 L0.928571429,8.125 Z M5.88095238,0.625 L7.11904762,0.625 L7.11904762,1.875 L5.88095238,1.875 L5.88095238,0.625 Z M8.35714286,0.625 L9.5952381,0.625 L9.5952381,1.875 L8.35714286,1.875 L8.35714286,0.625 Z M10.8333333,0.625 L12.0714286,0.625 L12.0714286,1.875 L10.8333333,1.875 L10.8333333,0.625 Z M3.4047619,0.625 L4.64285714,0.625 L4.64285714,1.875 L3.4047619,1.875 L3.4047619,0.625 Z M0.928571429,0.625 L2.16666667,0.625 L2.16666667,1.875 L0.928571429,1.875 L0.928571429,0.625 Z",
    id: "Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "5.57142857 3.125 5.57142857 6.875 8.66666667 5.1628125"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteAddVideo);
export default __webpack_public_path__ + "static/media/icon-rte-add-video.8d3eac76a877a86f348981069c99b702.svg";
export { ForwardRef as ReactComponent };